<template>
  <v-container class="pa-0 mx-0">
    <v-row class="ma-0">
      <v-col cols="12" md="6" class="pa-0">
        <v-row class="ma-0" align="center" style="min-height: 100vh;">
          <v-spacer/>
          <div style="width:60%;">
            <img :src="'/files/logo-' + $vuetify.theme.name + '.png'" width="80px" class="mb-4"/>
            <v-card-title class="px-0">
              Inicia sesión en tu cuenta
            </v-card-title>
            <v-card-subtitle class="px-0 mb-6">
              Accede a tu panel y continúa donde te quedaste
            </v-card-subtitle>
            <v-form @submit.prevent="login" style="width: 100%;" class="login-form">
              
              <div class="text-subtitle-1 text-medium-emphasis">Usuario</div>

                <v-text-field v-model="email" variant="underlined"></v-text-field>

                <div class="text-subtitle-1 text-medium-emphasis d-flex align-center justify-space-between">
                  Contraseña
                  <a class="text-caption text-decoration-none" href="/forgot-password" rel="noopener noreferrer">
                    ¿Olvidaste tu contraseña?
                  </a>
                </div>
              
              <v-text-field
                v-model="password"
                :append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
                :type="visible ? 'text' : 'password'"
                variant="underlined"
                @click:append-inner="visible = !visible"
              ></v-text-field>

              <!--v-card-subtitle class="px-0 " style="text-align:center;">
                <v-checkbox v-model="remember_password" label="Recordar Contraseña"></v-checkbox>
              </v-card-subtitle-->
              <v-btn type="submit" color="primary" block style="text-transform:none;">Login</v-btn>
            </v-form>
            <v-alert v-if="error" type="error" class="mt-4" small style="width: 100%; font-size:13px; padding: 10px;">
              {{ error }}
            </v-alert>
            <v-row align="center" class="my-6 mx-0">
              <v-col>
                <v-divider />
              </v-col>
              <span class="mx-2">O</span>
              <v-col>
                <v-divider />
              </v-col>
            </v-row>
            <v-btn class="mt-4" variant="outlined" block>
              <img width="14px" class="mr-2" src="/files/google.svg"/>
              <span style="text-transform:none;">Iniciar Sesión con Google</span>
            </v-btn>
            <v-btn class="mt-4" variant="outlined" block>
              <img width="14px" class="mr-2" src="/files/X.svg" :style="$vuetify.theme.name=='dark'?'filter:invert(1);':''"/>
              <span style="text-transform:none;">Iniciar Sesión con X</span>
            </v-btn>
            <v-card-subtitle class="mt-6" style="text-align:center;">
              ¿Aún no tienes una cuenta?  <a class="text-decoration-none" href="/register" rel="noopener noreferrer">Regístrate gratis</a>
            </v-card-subtitle>
          </div>
          <v-spacer/>
        </v-row>
      </v-col>
      <v-col class="mr-6 my-6 d-flex flex-column justify-space-between" :style="'background:url(/files/login-' + $vuetify.theme.name + '.png); background-repeat: no-repeat; background-size: cover; border-radius:40px 0px 40px 0px;'">
        <div>
          <img :src="'/files/isotipo-' + $vuetify.theme.name + '.svg'" width="30px" class="ma-12" />
        </div>
        <div class="ma-6">
          <carousel />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>


<script lang="ts">
import { defineComponent, ref } from 'vue';
import { useAuthStore } from '@/store/auth';
import { useRouter } from 'vue-router';
import carousel from '../auth/carousel.vue'

export default defineComponent({
  name: 'Login',
  components:{
    carousel
  },
  data:()=>({
    visible: false,
    remember_password:false
  }),
  setup() {
    const authStore = useAuthStore();
    const email = ref('');
    const password = ref('');
    const error = ref('');
    // Initialize the router using useRouter hook
    const router = useRouter();
    const login = async () => {
      const request = await authStore.login(email.value, password.value);
        
      if (request.success) {
        router.push({ name: 'Dashboard' });
      }else{
        error.value = request.error || 'Login failed. Please check your credentials.';
      }
    };

    return {
      email,
      password,
      login,
      error
    };
  },
});

</script>

<style>
.login-form .v-field__input{
  padding: 5px 0px 0px 10px!important;
}
 .login-form .v-field__append-inner{
  padding:10px!important;
 }
</style>